import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Ticker from "@/components/landing/Ticker";
import Capabilities from "@/components/landing/Capabilities";
import Compliance from "@/components/landing/Compliance";
import WhyDefcoin from "@/components/landing/WhyDefcoin";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import MobileCta from "@/components/landing/MobileCta";
import Admin from "@/pages/Admin";

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Ticker />
        <Capabilities />
        <Compliance />
        <WhyDefcoin />
        <Contact />
      </main>
      <Footer />
      <MobileCta />
    </>
  );
}

function App() {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia("(max-width: 1023px)").matches);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 1023px)");
    const onChange = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return (
    <div className="App bg-[#0D0F12] text-slate-50">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position={isMobile ? "top-center" : "bottom-right"} />
    </div>
  );
}

export default App;
